import { FormBase } from '@app/shared/models/form-base.model';

export class KeyValuePair extends FormBase<string> {
    type: string;

    constructor(options: {} = {}) {
        super(options);
        this.controlType = 'keyvaluepair';
        this.type = options['type'] || '';
    }
}
